module.exports = __webpack_public_path__ + "r-v3/img/userInvite_white.af93a19c.svg";